const initialState = {
    codes: [],
    loading: false,
    error: null
};

const discountCodesReducer = (state = initialState, action) => {
    switch (action.type) {
        case "DISCOUNT_CODES_FETCH_REQUEST":
        case "DISCOUNT_CODE_ADD_REQUEST":
        case "DISCOUNT_CODE_DELETE_REQUEST":
        case "DISCOUNT_CODE_UPDATE_REQUEST":
            return { ...state, loading: true, error: null };

        case "DISCOUNT_CODES_FETCH_SUCCESS":
            return { ...state, loading: false, codes: action.payload };

        case "DISCOUNT_CODE_ADD_SUCCESS":
            return { ...state, loading: false, codes: [...state.codes, action.payload] };

        case "DISCOUNT_CODE_DELETE_SUCCESS":
            return {
                ...state,
                loading: false,
                codes: state.codes.filter(code => code.id !== action.payload)
            };

        case "DISCOUNT_CODE_UPDATE_SUCCESS":
            return {
                ...state,
                loading: false,
                codes: state.codes.map(code =>
                    code.id === action.payload.id ? action.payload : code
                )
            };

        case "DISCOUNT_CODES_FETCH_FAILURE":
        case "DISCOUNT_CODE_ADD_FAILURE":
        case "DISCOUNT_CODE_DELETE_FAILURE":
        case "DISCOUNT_CODE_UPDATE_FAILURE":
            return { ...state, loading: false, error: action.error };

        default:
            return state;
    }
};

export default discountCodesReducer;
